import {BasePureComponent} from "./BaseComponent";
import {Route} from "react-router";
import {NavAzioni} from "../layout";
import {Trad} from "./Trad";
import * as React from "react";

export class AsideMenu extends BasePureComponent {
    public constructor(props: any) {
        super(props);
    }

    public render() {
        return <div>
            <button className="kt-aside-close"
                    id="kt_aside_close_btn"><i className="la la-close"/></button>
            <div
                className="kt-aside  kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop"
                id="kt_aside">
                <div className="kt-aside__brand kt-grid__item " id="kt_aside_brand"
                     kt-hidden-height="65">
                    <div className="kt-aside__brand-logo">
                        <a href="index.html">
                            <img alt="Logo" src="images/logoInAR.png"/>
                        </a>
                    </div>
                    <div className="kt-aside__brand-tools">
                        <button
                            className="kt-aside__brand-aside-toggler kt-aside__brand-aside-toggler--active"
                            id="kt_aside_toggler">
                            <span className="custom-icon left-icon"></span>
                            <span className="custom-icon right-icon"></span>
                        </button>
                    </div>
                </div>
                <div className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid"
                     id="kt_aside_menu_wrapper">
                    <div id="kt_aside_menu"
                         className="kt-aside-menu kt-scroll ps ps--active-y"
                         data-ktmenu-vertical="1" data-ktmenu-scroll="1"
                         data-ktmenu-dropdown-timeout="500">
                        <ul className="kt-menu__nav kt-menu__nav--dropdown-submenu-arrow" id="aside_menu_items_toggler">
                            <Route path='/anagrafica/:ID_Anag/' render={(props) =>
                                <NavAzioni {...props as any} {...this.props as any} />}/>
                            <Route path='/Utente/' render={(props) =>
                                <NavAzioni {...props as any} {...this.props as any} />}/>
                            <Route path='/Gruppo/' render={(props) =>
                                <NavAzioni {...props as any} {...this.props as any} />}/>
                            <Route path='/Binder/:ID_Binder' render={(props) =>
                                <NavAzioni {...props as any} {...this.props as any} />}/>
                            <li className="kt-menu__item kt-menu__item--submenu"
                                aria-haspopup="true">
                                <a onClick={(e) => {
                                    e.preventDefault();
                                    this.goBack();
                                }} className="kt-menu__link kt-menu__toggle">
                                    <span className="kt-menu__link-icon la la-backward"/>
                                    <span
                                        className="kt-menu__link-text">{Trad.Trad("Indietro")}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    }

    private goBack() {
        window.history.back();
    }
}



// WEBPACK FOOTER //
// ./src/components/AsideMenu.tsx